import Rodape from "../../components/rodape";
import BannerProjects from "../../components/bannerProjects";
import BusinessOtimize from "../../components/businessOtimize";
import ErpMarcas from "../../components/erpMarcas";
import ComoFazemos from "../../components/comoFazemos";

function SmartsourcingErp() {
    return (
        <>
            <BannerProjects
                backgroundImage="../assets/cover-erp-smartsourcing.png"
                bgMobile="../assets/cover-erp-smartsourcing-mobile.png"
                title="/SMARTSOURCING"
                titleBold=""
                iconSrc="../assets/icone-projectiva-omnicore.png"
                iconAlt="Projectiva Omnicore"
                iconText="omni"
                iconTextBold="core"
                descriptionBold=""
                description={
                    <>
                        <span className="font-titillium-web-bold">
                            Atuamos como parceiros estratégicos, comprometidos
                            em ampliar a eficiência operacional da sua empresa,
                            maximizar o uso do ERP e garantir resultados reais.
                        </span>{" "}
                        Nosso diferencial está em identificar os profissionais
                        certos: com experiência comprovada em SAP, TOTVS e
                        Senior, que dominam a tecnologia, compreendem o negócio
                        e geram valor desde o primeiro dia.
                    </>
                }
                footerText="VERTICAL SOLUTIONS | ERP Excellence Center"
                buttonText="Quero me conectar"
                buttonColor="from-[#4B3BDB] via-[#4B3BDB] to-[#A002CB]"
                brand="omnicore"
            />
            <ComoFazemos
                title={
                    <>
                        Como{" "}
                        <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#4B3BDB] via-[#4B3BDB] to-[#A002CB]">
                            fazemos?
                        </span>
                    </>
                }
                cards={[
                    {
                        icon: "/assets/servicos/abordagem2_icon.svg",
                        iconHover: "/assets/servicos/abordagem2_icon.svg",
                        title: "Abordagem",
                        text: (
                            <>
                                Somos orientados a gerar valor. Mais que alocar,
                                mapeamos os desafios, entendemos o contexto do
                                cliente e construímos juntos a estratégia para o
                                time ideal. Buscamos profissionais com visão de
                                negócio e capacidade de gerar impacto real desde
                                o primeiro sprint.
                            </>
                        ),
                        glowColor: "#4B3BDB",
                        height: "400",
                    },
                    {
                        icon: "/assets/servicos/foco_icon.svg",
                        iconHover: "/assets/servicos/foco_icon.svg",
                        title: "Foco",
                        text: (
                            <>
                                Entregamos performance com as pessoas certas nos
                                papéis certos. Com atuação multissistema (SAP,
                                TOTVS E Senior), garantimos perfis que dominam
                                tanto o ERP quanto a operação da empresa. Nossa
                                prioridade é a eficiência e a fluidez da
                                operação e não a ocupação de vagas.
                            </>
                        ),
                        glowColor: "#4B3BDB",
                        height: "400",
                    },
                    {
                        icon: "/assets/servicos/entrega_icon.svg",
                        iconHover: "/assets/servicos/entrega_icon.svg",
                        title: "Entrega",
                        text: (
                            <>
                                Atuamos de forma completa, da seleção à
                                performance. Com gestão ativa, rituais de
                                alinhamento e indicadores claros, asseguramos
                                que o time entregue valor real e mantenha ritmo
                                de evolução. Você não contrata um profissional:
                                ganha um parceiro comprometido com resultado
                            </>
                        ),
                        glowColor: "#4B3BDB",
                        height: "400",
                    },
                ]}
            />
            <ErpMarcas />
            <BusinessOtimize
                title={
                    <>
                        <span className="font-inter-bold">
                            Especialistas dedicados a entregas efetivas,
                        </span>
                        <br />
                        com resultados reais.
                    </>
                }
                buttonText="Otimize seu negócio"
                buttonTextColor="from-[#4B3BDB] to-[#4B3BDB]"
                backgroundImage="../assets/banner-erp-otimize.png"
                bgMobile="../assets/banner-erp-otimize-mobile.png"
                buttonLink="/"
            />
            <Rodape />
        </>
    );
}

export default SmartsourcingErp;
